import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";

export default class Info{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        this.templ(_wrapper);
    }

    /**
     * 카카오게임 체널링 관련 문구를 옵션으로 받지 않고 스테틱하게 처리하였다. 작업중인 현재 러브비트 한군데에서만 사용하고, 딱히 동적으로 만들 필요가 없기 때문.
     */
    templ(_parent: HTMLElement){
        if(this.ds.config.isKakaoGamesChannel){
            const infoEl = makeEl('div', _parent, {class: 'footer-copyright-kakaogameschannel'});

            infoEl.innerHTML = `
                <span>Copyright © <a href="http://www.kakaogames.com" target="_blank">Kakao Games Corp.</a> All rights reserved.</span>
            `;
        }
    }
}

